import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container">
      <div className="card stack">
        <h1 className="h1">Page not found</h1>
        <p className="muted">The page you're looking for doesn't exist.</p>
        <Link to="/admin" className="btn">Go to dashboard</Link>
      </div>
    </div>
  );
}
